import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const useStyles = makeStyles(() => ({
  root: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',

    '&.checked': {
      '& .check-box': {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
      },

      '& svg': {
        display: 'inline-block',
        color: 'var(--color-colorPrimary-main)',
      },
    },

    '&.disabled': {
      '& .check-box': {
        backgroundColor: 'transparent',
        borderColor: 'var(--color-checkbox-disabled-bg)',
      },

      '&.checked': {
        '& .check-box': {
          backgroundColor: 'transparent',
          borderColor: 'transparent',
        },

        '& svg': {
          display: 'inline-block',
          color: 'var(--color-checkbox-disabled-bg)',
        },
      },
    },

    '& .check-box': {
      width: 18,
      height: 18,
      border: '2px solid',
      borderColor: 'var(--color-checkbox-border)',
      borderRadius: 2,
    },

    '& svg': {
      position: 'relative',
      display: 'none',
      left: '-5px',
      top: '-5px',
    },
  },
}));

const Checkbox = ({
  checked = false,
  onChange = () => {},
  disabled = false,
  className = '',
}) => {
  const classes = useStyles();

  return (
    <button
      className={`${classes.root} ${checked ? 'checked' : ''} ${
        disabled ? 'disabled' : ''
      } ${className}`}
      onClick={onChange}
      disabled={disabled}
    >
      <div className="check-box">
        <CheckBoxIcon />
      </div>
    </button>
  );
};

export default Checkbox;
